import { render } from "./VideoEdit.vue?vue&type=template&id=6bf506cf&scoped=true"
import script from "./VideoEdit.vue?vue&type=script&lang=js"
export * from "./VideoEdit.vue?vue&type=script&lang=js"

import "./VideoEdit.vue?vue&type=style&index=0&id=6bf506cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf506cf"],['__file',"src/components/mediaproperty/VideoEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bf506cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bf506cf', __exports__)) {
    api.reload('6bf506cf', __exports__)
  }
  
  module.hot.accept("./VideoEdit.vue?vue&type=template&id=6bf506cf&scoped=true", () => {
    api.rerender('6bf506cf', render)
  })

}


export default __exports__